import React, {FC} from 'react';
import styled, {css} from 'styled-components';

import {directHoverSelector} from '../../../../libs/shared/core/src/helpers/browser/hoverHelpers';
import {Icon, IconName} from '../../../../libs/shared/ui/src/components/icon/icon';
import {center, transparent} from '../../../../libs/shared/ui/src/styles/mixins';

/*
 * Props.
 */

export interface NavigationLineStandardIconProps {
  /** The icon to display. */
  iconName: IconName;
  /** Override the default icon color. */
  color?: string;
  /** Override the default hover color. */
  hoverColor?: string;
  isTransparent?: boolean;
}

/*
 * Style.
 */

interface IconStyleProps {
  $color: string | undefined;
  $hoverColor: string | undefined;
  $isTransparent: boolean | undefined;
}
const StyledIconDiv = styled.div<IconStyleProps>`
  color: ${(p) => p.$color || p.theme.icon};
  grid-area: icon;
  ${center()};
  ${(p) => maybeAddHoverStyle(p)};
  ${(p) => transparent(p.$isTransparent ?? false)}
`;

function maybeAddHoverStyle(props: IconStyleProps) {
  if (!props.$hoverColor) {
    return '';
  }

  return css`
    ${directHoverSelector} {
      color: ${props.$hoverColor};
    }
  `;
}

/*
 * Component.
 */

/** Standard icon for a P1 navigation line. */
export const NavigationLineStandardIcon: FC<NavigationLineStandardIconProps> = (props) => (
  <StyledIconDiv $color={props.color} $hoverColor={props.hoverColor} $isTransparent={props.isTransparent}>
    <Icon name={props.iconName} />
  </StyledIconDiv>
);
